import React, {useState} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, Box, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";

function TodoDialogEditTitle({ isOpen, onClose, eventTodo, setEventTodo }) {

    const [ _title, setTitle] = useState(eventTodo.title);

    function saveTodoItemTitle() {
        // Corrected syntax: added parentheses around the object
        setEventTodo((prev) => ({
            ...prev,
            title: _title
        }));
        onClose(); // Don't forget to close the dialog after saving!
    }


    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                To-Do Item Title
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{ pt: 2 }}>
                <TextField
                    fullWidth
                    label="Title"
                    value={_title}
                    onChange={(e) => setTitle(e.target.value)}
                    variant="outlined"
                    margin="dense"
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                    <Button variant="contained" onClick={saveTodoItemTitle}>Save</Button>
                </Box>
            </DialogContent>

        </Dialog>
    )
}

export default TodoDialogEditTitle;